import React, { Fragment } from 'react';
import format from 'date-fns/format';
import { withStyles } from 'tss-react/mui';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import ApiService from '../../../common/services/ApiService';
import Autocomplete from '../../../common/components/autocomplete/Autocomplete';
import Chisholm from '../../../common/config/Chisholm';
import WaveSelectField from '../../../common/components/form/WaveSelectField';
import Utils from "../../../common/services/Utils";
import { WaveDatePicker } from '../../../common/components/WaveDatePicker';

// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. Unsupported arrow function syntax.
//Unexpected value type of CallExpression.
const styles = theme => ({
  clearFilters: {
    color: theme.typography.color.primary,
    '&:hover': {
      color: theme.typography.color.primary,
      cursor: 'pointer',
    },
    '&:visited': {
      color: theme.typography.color.primary,
    },
    fontSize: theme.typography.pxToRem(13),
    marginRight: theme.typography.pxToRem(20),
    opacity: 0.7,
  },
  filterHeader: {
    padding: `${theme.typography.pxToRem(19)} ${theme.typography.pxToRem(25)} 0 ${theme.typography.pxToRem(25)}`
  },
  filterBody: {
    paddingBottom: `${theme.typography.pxToRem(40)}`
  },
  ieFix: Utils.ieDatePickerFix()
});

const userStatusOptions = {
  'active': {
    id: 'active',
    label: 'Active',
  },
  'inactive': {
    id: 'inactive',
    label: 'Deactivated',
  }
};

const registrationStatusOptions = {
  'pending': {
    id: 'pending',
    label: 'Pending',
  },
  'approved': {
    id: 'approved',
    label: 'Approved',
  }
};

class ProgramRegistrationFilters extends React.Component {

  constructor(props) {
    super(props);
    this.api = new ApiService();

    const { passportPeriod } = props;

    this.state = {
      division_id: 'all',
      divisionOptions: [],
      department_id: 'all',
      departmentOptions: [],
      user_id: null,
      userLabel: '',
      supervisor_id: null,
      supervisorLabel: '',
      from_date: passportPeriod.from,
      to_date: passportPeriod.to,
      active: 'active', // user status
      domain_id: 'all',
      domainOptions: [],
      errorMessage: null,
      filters: {},
      status: 'all',
    };
  }

  componentDidMount() {
    this.getFiltersOptions();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.division_id !== prevState.division_id) {
      this.setState({ department_id: 'all' });
    };
  }

  arrayToObject = (arr, keyField) =>
    Object.assign({}, ...arr.map(item => ({[item[keyField]]: item}))
  );

  clearFilters = () => {
    const { passportPeriod } = this.props;

    this.setState({
      division_id: 'all',
      department_id: 'all',
      user_id: null,
      userLabel: '',
      supervisor_id: null,
      supervisorLabel: '',
      from_date: passportPeriod.from,
      to_date: passportPeriod.to,
      active: 'active', // user status
      domain_id: 'all',

      errorMessage: null,
      filters: {},
    });

    this.props.handleApplyFilters(this.state.filters);
  };

  getDepartments = (departments, divisionId) => {
    var departmentsArray = [];
    Object.keys(departments).map(obj =>
      departments[obj].division_id === divisionId ? departmentsArray.push(departments[obj]) : ''
    );
    return departmentsArray;
  };

  getFiltersOptions = () => {
    const divisionOptionsPromise = this.api.query('/api/v1/divisions/options');
    const departmentOptionsPromise = this.api.query('/api/v1/departments/options');
    const domainOptionsPromise = this.api.query('api/v1/domains/options');

    Promise.all([divisionOptionsPromise, departmentOptionsPromise, domainOptionsPromise])
    .then(([divisionOptions, departmentOptions, domainOptions]) => {
      this.setState({
        divisionOptions: divisionOptions,
        departmentOptions: departmentOptions,
        domainOptions: domainOptions
      });
    }).catch(this.processError);
  };

  handleAutocompleteChangeUser = (id, value) => {
    this.setState({ user_id: id, userLabel: value });
  };

  handleAutocompleteChangeSupervisor = (id, value) => {
    this.setState({ supervisor_id: id, supervisorLabel: value });
  };

  handleDateChange = (name, date) => {
    const convertedDate = date == null ? null : format(new Date(date), 'yyyy-MM-dd');
    this.setState({ [name]: convertedDate });
  };

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({ [name]: value });
  };

  makeFieldProps = (fieldName, fieldValue) => {
    return {
      name: fieldName,
      onChange: this.handleInputChange,
      value: fieldValue,
    };
  };

  onFilter = () => {
    var filters = {};

    if (![null, 'all'].includes(this.state.division_id)) {
      filters['user_effective_division_id_eq'] = this.state.division_id;
    }
    if (![null, 'all'].includes(this.state.department_id)) {
      filters['user_department_id_eq'] = this.state.department_id;
    }
    if (this.state.active != null && this.state.active != 'all') {
      filters['user_active_eq'] = this.state.active === 'active' ? '1' : '0';
    }
    if (this.state.user_id != null && this.state.user_id != 'all') {
      filters['user_id_eq'] = this.state.user_id;
    }
    if (this.state.supervisor_id != null && this.state.supervisor_id != 'all') {
      filters['user_supervisor_id_eq'] = this.state.supervisor_id;
    }
    if (this.state.from_date != null && this.state.to_date != null) {
      filters['date_from_eq'] = this.state.from_date;
      filters['date_to_eq'] = this.state.to_date;
    }
    if (this.state.domain_id != null && this.state.domain_id != 'all') {
      filters['program_domain_id_eq'] = this.state.domain_id;
    }
    if (this.state.status != null && this.state.status != 'all') {
      filters['status_eq'] = this.state.status;
    }

    this.props.handleApplyFilters(filters);
  }

  // unexpected errors
  processError = (ex) => {
    console.error(ex);
    this.setState({ ...s, errorMessage: ex.message });
  };

  render() {
    const { classes } = this.props;
    var { division_id, divisionOptions, department_id, departmentOptions, from_date, to_date, active, supervisorLabel, userLabel, domain_id, domainOptions, status } = this.state;
    var divisionIdInt = parseInt(division_id);
    var departmentsArray = this.getDepartments(departmentOptions, divisionIdInt);
    var filteredDepartments = this.arrayToObject(departmentsArray, 'id');

    return (
      <Fragment>
        <Grid
          container
          className={classes.filterHeader}
          alignItems="center"
          justifyContent="space-between"
          >
          <Typography variant="h6">Filter</Typography>
          <Grid>
            <a
              className={classes.clearFilters}
              onClick={() => this.clearFilters()}
              >
              Clear
            </a>
            <Button
              color="secondary"
              onClick={() => this.onFilter()}
              size="small"
              variant="contained"
              >
              <Typography variant="button">Filter</Typography>
            </Button>
          </Grid>
        </Grid>

        <Grid container spacing={3} className={[classes.filterHeader, classes.filterBody]}>

          <Grid size={3}>
            <WaveSelectField
              filterByAllItem
              filterByAllItemLabel="All"
              noValidation
              label="Division"
              menuItems={divisionOptions}
              {...this.makeFieldProps('division_id', division_id)}
              />
          </Grid>
          <Grid size={3}>
            <WaveSelectField
              filterByAllItem
              filterByAllItemLabel="All"
              noValidation
              label="Department"
              menuItems={divisionIdInt ? filteredDepartments : departmentOptions}
              {...this.makeFieldProps('department_id', department_id)}
              />
          </Grid>
          <Grid size={3}>
            <WaveSelectField
              filterByAllItem
              filterByAllItemLabel="All"
              noValidation
              label="Domain"
              menuItems={domainOptions}
              {...this.makeFieldProps('domain_id', domain_id)}
              />
          </Grid>
          <Grid size={3}>
            <WaveSelectField
              filterByAllItem
              filterByAllItemLabel="All"
              noValidation
              label="User Status"
              menuItems={userStatusOptions}
              {...this.makeFieldProps('active', active)}
              />
          </Grid>

          <Grid size={3}>
            <Autocomplete
              label="User"
              name="user_id"
              onChange={this.handleAutocompleteChangeUser}
              role={['educator', 'guest']}
              value={userLabel || ''}
              />
          </Grid>
          <Grid size={3}>
            <Autocomplete
              label="Supervisor"
              name="supervisor_id"
              onChange={this.handleAutocompleteChangeSupervisor}
              role={['supervisor', 'department_manager', 'division_manager']}
              value={supervisorLabel || ''}
              />
          </Grid>
          <Grid size={2}>
            <WaveDatePicker
              className={classes.ieFix}
              format={Chisholm.rangeDate}
              label="From"
              name="from_date"
              onChange={(value) => this.handleDateChange('from_date', value)}
              value={from_date}
              />
          </Grid>
          <Grid size={2}>
            <WaveDatePicker
              className={classes.ieFix}
              format={Chisholm.rangeDate}
              label="To"
              name="to_date"
              onChange={(value) => this.handleDateChange('to_date', value)}
              value={to_date}
              />
          </Grid>
          <Grid size={2}>
            <WaveSelectField
              filterByAllItem
              filterByAllItemLabel="All"
              noValidation
              label="Approval Status"
              menuItems={registrationStatusOptions}
              {...this.makeFieldProps('status', status)}
              />
          </Grid>

        </Grid>

      </Fragment>
    );
  }

}

export default withStyles(ProgramRegistrationFilters, styles, { withTheme: true });
